export const mainBlackColor = "#222222";

export const searchBarHeight = 74;

export const searchBarHeightMobile = 80;

export const bottomNavbarHeight = 56;

export const formBorderColor = "grey.500";

export const borderRadius = 4;

export const searchBarBorderColor = "grey.300";
export const searchBarBackgroundColor = "grey.100";
export const searchBarTransitionTime = 300;
export const searchBarTimingFunction = "cubic-bezier(0.4, 0, 0.2, 1)";

export const raiseOnHoverBoxShadow =
  "0px 3px 3px -2px rgb(0 0 0 / 20%), 0px 3px 4px 0px rgb(0 0 0 / 14%), 0px 1px 8px 0px rgb(0 0 0 / 12%)";

export const appSidePadding = { xs: 3, md: 5, lg: 7, xl: 10 };
export const appSidePaddingAlt = { xs: 3 };

export const desktopMinWidth = "(min-width:750px)";
